import { useState, useEffect } from 'react';

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            
            // Check for mobile user agents
            const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
            
            // Check for iPadOS 13+ (which often reports as Macintosh but has touch points)
            const isiPad = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

            // Fallback to screen width for development/responsive testing
            const isSmallScreen = window.innerWidth < 1024;

            setIsMobile(isMobileUA || isiPad || isSmallScreen);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    return isMobile;
};

